import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub, faHtml5, faCss3Alt, faReact,
  faBootstrap, faPhp, faLaravel, faNodeJs, faPython,
  faJava,
  faGit,
} from '@fortawesome/free-brands-svg-icons';
import {
  faDatabase, faServer, faMobileScreenButton,
} from '@fortawesome/free-solid-svg-icons';
//import Footer from '../Footer';
import './Skills.css';

/* ─── Animation variants ─────────────────────────────────────── */
var fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] } },
};

var stagger = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.07 } },
};

/* ─── Skill categories ───────────────────────────────────────── */
var CATEGORIES = [
  {
    label: 'Frontend',
    skills: [
      { title: 'HTML5',      icon: faHtml5,             color: '#e34f26', level: 100 },
      { title: 'CSS3',       icon: faCss3Alt,           color: '#1572b6', level: 100 },
      { title: 'Bootstrap',  icon: faBootstrap,         color: '#7952b3', level: 100 },
      { title: 'React.js',   icon: faReact,             color: '#61dafb', level: 100 },
      { title: 'Next.js',    icon: faReact,             color: '#042a35', level: 100 },
      { title: 'JavaScript', icon: faJava,             color: '#08b68e', level: 100 },
    ],
  },
  {
    label: 'Backend',
    skills: [
      { title: 'PHP',        icon: faPhp,               color: '#777bb4', level: 100 },
      { title: 'Laravel',    icon: faLaravel,           color: '#ff2d20', level: 90 },
      { title: 'Node.js',    icon: faNodeJs,            color: '#339933', level: 95 },
      { title: 'Python',     icon: faPython,            color: '#3776ab', level: 80 },
      { title: 'NestJS',     icon: faNodeJs,            color: '#0587f2', level: 100 },
       { title: 'Express.js',icon: faNodeJs,            color: '#062743', level: 100 },
      { title: 'Java',       icon: faJava,              color: '#8e9aa4', level: 75 },
    ],
  },
  {
    label: 'Tools & More',
    skills: [
      { title: 'GitHub',     icon: faGithub,            color: '#f0f0f0', level: 100 },
      { title: 'MySQL',      icon: faDatabase,          color: '#c9a84c', level: 90 },
      { title: 'REST APIs',  icon: faServer,            color: '#6b8f71', level: 98 },
      { title: 'Responsive', icon: faMobileScreenButton,color: '#c9a84c', level: 92 },
      { title: 'Swagger-UI', icon: faServer,            color: '#0587f2', level: 100 },
      { title: 'PostgreSQL', icon: faDatabase,          color: '#a7cbe9', level: 100 },
      { title: 'Git',        icon: faGit,               color: '#8e087e', level: 100 },
    ],
  },
];

/* ─── Component ──────────────────────────────────────────────── */
var Skills = function() {
  return (
    <motion.div
      className="skills-root"
      initial="hidden"
      animate="show"
      variants={stagger}
    >

      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="skills-hero" aria-label="Skills header">
        <div className="skills-hero__glow" aria-hidden="true" />
        <Container>
          <motion.span className="home-label" variants={fadeUp}>Expertise</motion.span>
          <motion.h1 className="skills-hero__title" variants={fadeUp}>
            Skills &amp; <em>Technologies</em>
          </motion.h1>
          <motion.p className="skills-hero__sub" variants={fadeUp}>
            A curated overview of the tools and technologies I use to build
            modern, high-performance web applications.
          </motion.p>
        </Container>
      </section>

      {/* ── Skill categories ─────────────────────────────────── */}
      {CATEGORIES.map(function(cat) {
        return (
          <section
            key={cat.label}
            className={'skills-section' + (cat.label === 'Backend' ? ' skills-section--alt' : '')}
            aria-labelledby={'cat-' + cat.label}
          >
            <Container>
              <motion.div className="home-section__header" variants={fadeUp}>
                <span className="home-label">{cat.label}</span>
                <h2 id={'cat-' + cat.label} className="home-section__title">{cat.label} Skills</h2>
              </motion.div>

              <motion.div className="skills-grid" variants={stagger}>
                {cat.skills.map(function(skill) {
                  return (
                    <motion.div
                      key={skill.title}
                      className="skill-card"
                      variants={fadeUp}
                      whileHover={{ y: -6, transition: { duration: 0.25 } }}
                    >
                      {/* Icon */}
                      <div
                        className="skill-card__icon"
                        style={{ '--skill-color': skill.color }}
                        aria-hidden="true"
                      >
                        <FontAwesomeIcon icon={skill.icon} />
                      </div>

                      {/* Title */}
                      <h3 className="skill-card__title">{skill.title}</h3>

                      {/* Progress bar */}
                      <div className="skill-card__bar-wrap" aria-label={skill.title + ' proficiency ' + skill.level + '%'}>
                        <div className="skill-card__bar-track">
                          <motion.div
                            className="skill-card__bar-fill"
                            style={{ '--skill-color': skill.color }}
                            initial={{ scaleX: 0 }}
                            animate={{ scaleX: skill.level / 100 }}
                            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
                          />
                        </div>
                        <span className="skill-card__bar-pct">{skill.level}%</span>
                      </div>
                    </motion.div>
                  );
                })}
              </motion.div>
            </Container>
          </section>
        );
      })}
    </motion.div>
  );
};

export default Skills;